module.exports = __webpack_public_path__ + "static/media/B2B-news-network-logo-1@2x.e997e465.png";